export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "drewmanbetting-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "drewmanbetting-themeWrapLive" */'./LiveThemeImporter'),
  },
};
